/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import Grid from "@mui/material/Grid";
import { loginImpersonate } from "@/src/store/login/actions";
import { useNavigate } from "react-router";
import { FormProvider, useForm } from "@/src/provider/Form/FormProvider";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/src/services/reactQuery/reactQueryService";
import { requiredFieldDefault } from "@/src/services/validationRules";
import { FormDataTypes } from "@/src/types/FormDataTypes";

export default function AdminPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const initialValues = {
    email: "",
    password: "",
    login: "",
  };

  const handleSubmit = async ({ values }: { values: FormDataTypes["values"] }) => {
    await loginImpersonate(values);
    await queryClient.invalidateQueries({
      queryKey: queryKeys.collection("/customers"),
    });
    navigate("/servicewelt");
  };

  return (
    <LayoutPublicRoutes minimal={true}>
      <Paper elevation={4} sx={{ maxWidth: 500, margin: "2rem auto", padding: "1rem" }}>
        <FormProvider initialValues={initialValues} submitAction={handleSubmit}>
          <AdminForm />
        </FormProvider>
      </Paper>
    </LayoutPublicRoutes>
  );
}

const AdminForm = () => {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid size={12}>
          <ValidatorTextField name="email" label="E-Mail" type="email" validators={[requiredFieldDefault]} />
        </Grid>
        <Grid size={12}>
          <ValidatorTextField name="password" label="Passwort" type="password" validators={[requiredFieldDefault]} />
        </Grid>
        <Grid size={12}>
          <ValidatorTextField name="login" label="Login (Mandantschaft)" type="email" validators={[requiredFieldDefault]} />
        </Grid>
        <Grid sx={{ paddingTop: "1rem" }} size={12}>
          <Button color={"primary"} type="submit" variant={"contained"} fullWidth>
            Abschicken
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
